import { LabelValuePairNode } from 'types/shared';

const topics = [
  'overview',
  'performance',
  'charts',
  'airplay',
  'territory',
  'social',
  'discoveries',
  'audience',
];

const topicsWithSubTopics: LabelValuePairNode<AllTopicTypes>[] = [
  {
    value: 'overview',
    label: 'Overview',
    children: [
      { value: 'summary', label: 'Summary' },
      { value: 'view', label: 'View Related' },
      { value: 'certifications', label: 'Certifications' },
      { value: 'concerts', label: 'Concerts' },
      { value: 'physical', label: 'Shipped Units' },
    ],
  },
  {
    value: 'performance',
    label: 'DSP Activity',
    children: [
      { value: 'streaming', label: 'Streaming' },
      { value: 'playlist', label: 'Playlist' },
      { value: 'download', label: 'Download' },
      { value: 'all', label: 'All' },
    ],
  },
  {
    value: 'charts',
    label: 'Chart Positions',
    children: [
      { value: 'positionTracker', label: 'Position Tracker' },
      { value: 'official', label: 'Official Charts' },
      { value: 'dsp', label: 'DSP Charts' },
      { value: 'radioCharts', label: 'Radio Charts' },
    ],
  },
  {
    value: 'airplay',
    label: 'Radio / Shazam',
    children: [
      { value: 'radio', label: 'Radio' },
      { value: 'discoveries', label: 'Shazam' },
    ],
  },
  {
    value: 'social',
    label: 'Social Media',
    children: [
      { value: 'engagement', label: 'Engagement' },
      { value: 'shortFormVideo', label: 'Short Form Video' },
      // { value: 'linkfire', label: 'Linkfire' },
    ],
  },
  {
    value: 'audience',
    label: 'Audience',
    children: [
      { value: 'ageGender', label: 'Age & Gender' },
      { value: 'territory', label: 'Territory' },
    ],
  },
];

const overviewSubTopics: LabelValuePairNode<AllTopicTypes>[] =
  topicsWithSubTopics[0].children as any;

const performanceSubTopics: LabelValuePairNode<AllTopicTypes>[] =
  topicsWithSubTopics[1].children as any;

const chartsSubTopics: LabelValuePairNode<AllTopicTypes>[] =
  topicsWithSubTopics[2].children as any;

const airplaySubTopics: LabelValuePairNode<AllTopicTypes>[] =
  topicsWithSubTopics[3].children as any;

const socialSubTopics: LabelValuePairNode<AllTopicTypes>[] =
  topicsWithSubTopics[4].children as any;

const audienceSubTopics: LabelValuePairNode<AllTopicTypes>[] =
  topicsWithSubTopics[5].children as any;

export type ParentTopicTypes =
  | 'overview'
  | 'performance'
  | 'charts'
  | 'airplay'
  | 'social'
  | 'audience'
  | 'topLists'
  | 'playlistActivity';

export type SubTopicTypes =
  | 'summary'
  | 'view'
  | 'certifications'
  | 'concerts'
  | 'streaming'
  | 'playlist'
  | 'download'
  | 'physical'
  | 'all'
  | 'positionTracker'
  | 'dsp'
  | 'official'
  | 'radioCharts'
  | 'radio'
  | 'discoveries'
  | 'engagement'
  | 'shortFormVideo'
  | 'linkfire'
  | 'territory'
  | 'ageGender';

export type AllTopicTypes = ParentTopicTypes | SubTopicTypes;

export type FeedTypes = Omit<AllTopicTypes, 'download'> | 'downloads';

export default topics;

export {
  topics,
  topicsWithSubTopics,
  overviewSubTopics,
  performanceSubTopics,
  chartsSubTopics,
  airplaySubTopics,
  socialSubTopics,
  audienceSubTopics,
};
